var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressPhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D0D8DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2935 35.5205H13.7067C13.0135 32.9745 13.0765 30.4915 13.4042 28.3236V28.311C13.8383 25.2265 14.6517 23.6307 15.383 21.8325C18.0172 15.8079 15.7738 12.4805 15.7738 12.4805H28.2265C28.2265 12.4805 25.983 15.8079 28.6172 21.8326C29.3187 23.4803 30.1975 25.2818 30.596 28.3237C30.9237 30.4915 30.9868 32.9745 30.2935 35.5205Z",
    fill: "#FCCC67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5979 28.3239C29.2347 28.3767 25.1787 28.6263 23.3211 31.6886C22.3268 33.3253 22.5835 35.0194 22.5435 35.519H21.4587C21.4187 35.0184 21.6723 33.3115 20.6811 31.6886C18.8139 28.6263 14.7531 28.3766 13.4043 28.3094C13.7647 25.758 14.441 24.1579 14.6379 23.5479C16.8219 24.2007 19.4907 24.3927 22.0011 24.3783C24.5067 24.3927 27.1659 24.2007 29.3499 23.5479C29.5969 24.0418 30.31 26.13 30.5979 28.3239Z",
    fill: "#D25C59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 22.2243C22.3807 22.2243 22.6893 21.9157 22.6893 21.535C22.6893 21.1543 22.3807 20.8457 22.0001 20.8457C21.6194 20.8457 21.3108 21.1543 21.3108 21.535C21.3108 21.9157 21.6194 22.2243 22.0001 22.2243Z",
    fill: "#EBB760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressPhotos);
export default __webpack_public_path__ + "static/media/ProgressPhotos.69c81c455d57b247c6ad8bae991fca7f.svg";
export { ForwardRef as ReactComponent };